// extracted by mini-css-extract-plugin
export var bold = "PriceSummary_bold__cPbPd";
export var itemPrice = "PriceSummary_itemPrice__ACtuq";
export var itemPriceDivider = "PriceSummary_itemPriceDivider__80wfc";
export var priceHeadline = "PriceSummary_priceHeadline__VcwhS";
export var pricePlanSummary = "PriceSummary_pricePlanSummary__obM7T";
export var pricesPlanDetail = "PriceSummary_pricesPlanDetail__avH7g";